<template>
  <div class="c-w-100">
    <p v-if="label">
      {{ label }}
      <span style="color: red" v-if="isRequired">*</span>
    </p>
    <div class="is-relative">
      <input
        ref="inputOffering"
        :type="type"
        class="input mt-2 border-input input-offering"
        :class="[{'error': !value && showError}, classInput]"
        :placeholder="placeholder"
        :value="value"
        @input="handleInput"
        @change="handleChangeValidate"
      />
      <ButtonApp
        v-if="showValidateButton && value"
        class="btn-validate"
        borderRadius="8px"
        :isSecondary="isVolumeValid"
        :isDisabled="isLoadingValidate"
        @click="onValidateClick"
      >
        <p>Cek</p>
      </ButtonApp>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InputOffering',
  props: {
    value: [String, Number],
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'number'
    },
    min: {
      type: [String, Number],
      default: null
    },
    max: {
      type: [String, Number],
      default: null
    },
    classInput: {
      type: String,
      default: ''
    },
    isRequired: {
      type: Boolean,
      default: true
    },
    showValidateButton: {
      type: Boolean,
      default: false
    },
    isVolumeValid: Boolean,
    isLoadingValidate: Boolean,
    showError: Boolean
  },
  components: {
    ButtonApp: () => import('@/components/button/ButtonApp.vue')
  },
  data () {
    return {}
  },
  methods: {
    handleInput (event) {
      this.$emit('input', this.type === 'number' ? event.target.value === '' ? '' : Number(event.target.value) : event.target.value)
    },
    handleChangeValidate () {
      this.$emit('change')
    },
    onValidateClick () {
      this.$emit('validate-click')
    },
    setInputAttributes () {
      const inputEl = this.$refs.inputOffering
      if (inputEl) {
        if (this.min !== null && this.min !== undefined) {
          inputEl.setAttribute('min', this.min)
        } else {
          inputEl.removeAttribute('min')
        }

        if (this.max !== null && this.max !== undefined) {
          inputEl.setAttribute('max', this.max)
        } else {
          inputEl.removeAttribute('max')
        }
      }
    }
  },
  mounted () {
    this.setInputAttributes()
  },
  watch: {
    min () {
      this.setInputAttributes()
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/scss/_variables.scss';

.border-input {
  border: 1px solid $color-grey-2;
  border-radius: 10px;
}

.btn-validate {
  position: absolute;
  z-index: 2;
  top: 15px;
  right: 6px;
}

.input-offering {
  height: 42px;
  font-size: 14px;
}

.input-offering.error {
  border: 1px solid $color-red-1;
  background: $color-pink-5;
}

.input-offering.error::placeholder {
  color: $color-red-1;
  opacity: 0.5; /* Firefox */
}

.input-offering.error::-ms-input-placeholder { /* Edge 12 -18 */
  color: $color-red-1;
  opacity: 0.5; /* Firefox */
}

.input-number {
  width: 13em;
}

.input-with-btn {
  width: calc(10em + 10px) !important;
}

@media only screen and (max-width: 600px) {
  .input-number {
    width: 100% !important;
  }
}
</style>
